export const baseUrl = (chemin) => {
    let base = "https://skanci.com/mobilepaymentadminapi/public/api/"+chemin
    // let base = "http://192.168.1.14:8000/api/" + chemin
    return base
}

//admin@gmail.com
//admin@skanpay